import request from '../request';
import { renewalAPI } from './urls';

// User Story 5: Renewal Management Service

const GetUpcomingRenewals = (renewalWindowWeeks = null) => {
  const params = new URLSearchParams();
  if (renewalWindowWeeks) params.append('renewalWindowWeeks', renewalWindowWeeks);
  return request({
    url: renewalAPI.GetUpcomingRenewals(renewalWindowWeeks),
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

const ProcessRenewal = (renewalData) => {
  return request({
    url: renewalAPI.ProcessRenewal(),
    method: 'POST',
    data: renewalData,
  })
    .then((response) => response)
    .catch((error) => error);
};

const CancelSubscriptionFromRenewal = (subscriptionId, cancellationReason) => {
  return request({
    url: renewalAPI.CancelSubscriptionFromRenewal(),
    method: 'POST',
    data: { SubscriptionId: subscriptionId, CancellationReason: cancellationReason },
  })
    .then((response) => response)
    .catch((error) => error);
};

const ProcessBulkRenewals = (renewals) => {
  return request({
    url: renewalAPI.ProcessBulkRenewals(),
    method: 'POST',
    data: renewals,
  })
    .then((response) => response)
    .catch((error) => error);
};

const GetRenewalWindowWeeks = () => {
  return request({
    url: renewalAPI.GetRenewalWindowWeeks(),
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

const UpdateRenewalWindowWeeks = (weeks) => {
  return request({
    url: renewalAPI.UpdateRenewalWindowWeeks(),
    method: 'PUT',
    data: { Weeks: weeks },
  })
    .then((response) => response)
    .catch((error) => error);
};

const renewalService = {
  GetUpcomingRenewals,
  ProcessRenewal,
  CancelSubscriptionFromRenewal,
  ProcessBulkRenewals,
  GetRenewalWindowWeeks,
  UpdateRenewalWindowWeeks,
};

export default renewalService;
